/**
 * 业绩统计 - 表格列配置和工具函数
 */

import React from 'react';
import { Button, Space, Progress, Tooltip } from 'antd';
import { TeamOutlined, EyeOutlined, TrophyOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { DepartmentPerformanceSummary } from '../../../../services/administrationService';

// 排名徽章渲染
export const renderRankBadge = (rank: number | null) => {
    if (rank === null) return '-';
    let color = '#d9d9d9';
    if (rank === 1) color = '#fadb14'; // Gold
    if (rank === 2) color = '#d3d3d3'; // Silver
    if (rank === 3) color = '#b87333'; // Bronze

    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 24, height: 24, borderRadius: '50%', background: color, color: '#fff'
        }}>
            {rank <= 3 ? <TrophyOutlined /> : rank}
        </span>
    );
};

interface GetColumnsParams {
    viewDepartmentDetail: (departmentId: number) => void;
}

export const getPerformanceColumns = ({
    viewDepartmentDetail
}: GetColumnsParams): ColumnsType<DepartmentPerformanceSummary> => [
        {
            title: '排名',
            dataIndex: 'rank',
            key: 'rank',
            width: 80,
            align: 'center',
            render: renderRankBadge,
        },
        {
            title: '部门',
            dataIndex: 'department_name',
            key: 'department_name',
            render: (text) => (
                <Space>
                    <TeamOutlined />
                    <span style={{ fontWeight: 500 }}>{text}</span>
                </Space>
            ),
        },
        {
            title: '总得分',
            dataIndex: 'total_score',
            key: 'total_score',
            width: 120,
            align: 'center',
            render: (score: number) => (
                <span style={{
                    fontSize: 16, fontWeight: 600,
                    color: score >= 80 ? '#52c41a' : score >= 60 ? '#faad14' : '#ff4d4f'
                }}>
                    {score.toFixed(1)}
                </span>
            ),
        },
        {
            title: '完成进度',
            key: 'progress',
            width: 200,
            render: (_, record) => {
                const percent = Math.min(record.total_score, 100);
                return (
                    <Progress
                        percent={percent}
                        status={percent >= 80 ? 'success' : percent < 60 ? 'exception' : 'normal'}
                        size="small"
                        format={(p) => `${p?.toFixed(1)}%`}
                    />
                );
            },
        },
        {
            title: '操作',
            key: 'action',
            width: 100,
            align: 'center',
            render: (_, record) => (
                <Tooltip title="查看详情">
                    <Button type="link" icon={<EyeOutlined />} onClick={() => viewDepartmentDetail(record.department)} />
                </Tooltip>
            ),
        },
    ];
